import {
  SET_ACCOUNT_FORM,
  SET_ACCOUNT_FORM_FIELD,
  MERGE_ACCOUNT_FORM
} from './actionTypes'

export const setAccountForm = data => {
  return {
    type: SET_ACCOUNT_FORM,
    data
  }
}

export const mergeAccountForm = data => {
  return {
    type: MERGE_ACCOUNT_FORM,
    data
  }
}

export const setAccountFormField = (field, value) => {
  return {
    type: SET_ACCOUNT_FORM_FIELD,
    field,
    value
  }
}
